import { JGGL_URLS } from '@/configs/jggl'

type JgglUrls = {
  appStore: string
  googlePlay: string
  website: string
}

type DeviceHints = {
  userAgent: string
  platform?: string
  maxTouchPoints?: number
}

const HUAWEI_PATTERN = /HMSCore|HarmonyOS|HONOR|HUAWEI/i
const IOS_PATTERN = /iPad|iPhone|iPod/i
const ANDROID_PATTERN = /Android/i

export function resolveJgglUrl(
  { userAgent, platform = '', maxTouchPoints = 0 }: DeviceHints,
  urls: JgglUrls = JGGL_URLS
): string {
  if (HUAWEI_PATTERN.test(userAgent)) {
    return urls.website
  }

  const isIPadOs =
    (/Macintosh/i.test(userAgent) || platform === 'MacIntel') &&
    maxTouchPoints > 1

  if (IOS_PATTERN.test(userAgent) || isIPadOs) {
    return urls.appStore
  }

  if (ANDROID_PATTERN.test(userAgent)) {
    return urls.googlePlay
  }

  return urls.website
}
